import { toast } from "react-toastify";

import { v4 as uuid } from 'uuid';
import axiosinstances from '../Helper/useAxios';


export async function  claimdataservices(credentialclaim)  {
  const [axiosInstance] = axiosinstances()
const details = credentialclaim.payload.values
  details.entityId = credentialclaim.payload.id
  //console.log('credentialclaim', details)
    const d=sessionStorage.getItem('token') && JSON.parse(sessionStorage.getItem('token')).token ? JSON.parse(sessionStorage.getItem('token')).token : "";
    const e=JSON.parse(sessionStorage.getItem('token'))
    const unique_id = uuid();
    return  axiosInstance
    .post(`/api/v1/virtual-balance/claim/create`,details, { headers: { "Authorization": `Bearer ${e}`, "client-id": credentialclaim.payload.id, "role": "ROLE_RETAILER_FINXPAY" } })
    .then((response) => {
    //  console.log('response', response.response)
      if(response !== undefined && response?.response?.status !== undefined &&  response?.response?.status === 500){
        toast.error("Transaction id is not correct and may be repeat");
      }else if (response !== undefined) {
        
        return response.data;
      }
      return false;
    })
   .catch((err) => {
      console.log(err);
   });
// return axios.post(
//             "http://qa.finxpay.co.in/api/v1/virtual-balance/claim/create",
//             details,
//             { headers: { "Authorization": `Bearer ${e}`, "client-id": credentialclaim.payload.id, "role": "ROLE_RETAILER_FINXPAY" } }
//         )
//         .then((response) => {
//             if (response) {
//               return response.data;
//             }
//             return false;
//           });
}

export default claimdataservices